export default {
  landing: {
    pageTitle: 'Hostinator — Game servers & custom hosting',
    badge: 'Getting ready for launch',
    title: 'You bring the friends.',
    highlight: 'We host the game.',
    description: 'We’re preparing hosting for Minecraft, Valheim and many more games, available when our website launches. Custom hosting is available on request.',
    contact: 'Let’s talk',
    explore: 'Explore our hosting',
    notice: 'Our new website is in the works. Get in touch about the launch or a custom hosting solution. Existing hosted services continue to run.',
    visualLabel: 'Coming with our website launch',
    minecraftTag: 'Build a world together',
    valheimTag: 'Set out on an adventure with friends',
    exilTag: 'Already hosted on Hostinator',
    more: 'many more games',
    wishlist: 'Add to your Steam wishlist',
    visualFooter: 'YOUR GAME. YOUR COMMUNITY. OUR HOSTING.',
    gamesEyebrow: 'Coming soon',
    gamesTitle: 'Your games, ready at launch.',
    gamesIntro: 'Minecraft, Valheim and many more games will be available when our website launches.',
    minecraftDescription: 'A world for you and your community. Minecraft hosting for building, exploring and sharing adventures.',
    valheimDescription: 'A home for your clan. Explore, build and conquer the world of Valheim with your friends.',
    moreGamesTitle: '+ many more games',
    moreGamesDescription: 'We’re preparing a wider range of game servers, available when our website launches.',
    customTitle: 'Custom hosting, on request',
    customDescription: 'Developing your own game or a project with specific requirements? We can set up a custom hosting solution for you right now.',
    exilProof: 'Exil Island is already hosted on Hostinator.',
    exilDescription: 'Discover the game on Steam and support it with a wishlist.',
    contactTitle: 'What would you like to bring online?',
    contactDescription: 'Questions about the launch or looking for custom hosting? Tell us what you have in mind.',
    footer: 'Hosting for games and custom projects.',
    loginHint: 'Need access? Get in touch at',
    menuToggle: 'Open or close menu',
  },
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    create: 'Create',
    edit: 'Edit',
    close: 'Close',
    refresh: 'Refresh',
    search: 'Search',
    back: 'Back',
    or: 'or',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    online: 'Online',
    offline: 'Offline',
    live: 'Live',
    connected: 'Connected',
    players: 'Players',
    version: 'Version',
    status: 'Status',
    details: 'Details',
    actions: 'Actions',
    free: 'Free',
    copied: 'Copied!',
  },

  // Navbar
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    admin: 'Admin',
    login: 'Login',
    getStarted: 'Get Started',
    logout: 'Logout',
  },

  // Home Page
  home: {
    badge: 'Server ready in 2 minutes',
    heroTitle: 'Game servers,',
    heroHighlight: 'simplified.',
    heroSubtitle: 'Host your Minecraft server instantly. No setup, no hassle.',
    startFree: 'Start Free',
    viewPlans: 'View Plans',
    whyUs: 'Why Hostinator?',
    whyUsSubtitle: 'Built for gamers, by gamers.',
    features: {
      instantSetup: 'Instant Setup',
      instantSetupDesc: 'Server online in under 2 minutes.',
      highPerformance: 'High Performance',
      highPerformanceDesc: 'Premium hardware, zero lag.',
      ddosProtected: 'DDoS Protected',
      ddosProtectedDesc: 'Your server stays online.',
      support: '24/7 Support',
      supportDesc: 'Help when you need it.',
    },
    pickPlan: 'Pick your plan',
    pickPlanSubtitle: 'Start free. Upgrade anytime.',
    popular: 'POPULAR',
    perMonth: 'RON/mo',
    ram: 'RAM',
    maxPlayers: 'players',
    readyToPlay: 'Ready to play?',
    readyToPlaySubtitle: 'Join thousands of gamers hosting with Hostinator.',
    createFreeServer: 'Create Free Server',
    footer: '© 2026 Hostinator. Built for gamers.',
    footerTagline: 'Every server comes with its own -inator.',
    packageFeatures: {
      autoShutdown: 'Auto-shutdown',
      basicSupport: 'Basic support',
      limitedFiles: 'Limited files',
      fullFileAccess: 'Full file access',
      allVersions: 'All versions',
      plugins: 'Plugins',
      uptime247: '24/7 uptime',
      customSubdomain: 'Custom subdomain',
      prioritySupport: 'Priority support',
      autoBackups: 'Auto backups',
      ssdStorage: 'SSD storage',
      premiumLocation: 'Premium location',
      dedicatedSupport: 'Dedicated support',
    },
  },

  // Login Page
  login: {
    title: 'Welcome back',
    newHere: 'New here?',
    createAccount: 'Create account',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    continueGoogle: 'Continue with Google',
    continueDiscord: 'Continue with Discord',
    failed: 'Login failed',
  },

  // Register Page
  register: {
    title: 'Create account',
    haveAccount: 'Already have one?',
    signIn: 'Sign in',
    name: 'Name',
    namePlaceholder: 'Your name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    createAccount: 'Create account',
    continueGoogle: 'Continue with Google',
    continueDiscord: 'Continue with Discord',
    terms: 'By creating an account, you agree to our Terms and Privacy Policy.',
    failed: 'Registration failed',
    passwordMismatch: 'Passwords do not match',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    greeting: 'Hey {{name}}!',
    newServer: 'New Server',
    noServers: 'No servers yet',
    noServersDesc: 'Create your first server to get started',
    createServer: 'Create Server',
    serverAddress: 'Server Address',
    loadServersError: 'Could not load your servers',
    loadPackagesError: 'Could not load available packages',
    retry: 'Retry',
    noPackages: 'No active Minecraft or Valheim package is available. Ask an administrator to publish one.',
  },

  // Server Card
  serverCard: {
    players: 'Players',
    ram: 'RAM',
    cpu: 'CPU limit',
    storage: 'Storage',
    version: 'Version',
    serverAddress: 'Server Address',
    dnsPending: 'DNS pending',
    viewDetails: 'Details',
    autoShutdownScheduled: 'Auto-shutdown scheduled for {{time}}.',
    autoShutdownWaiting: 'Auto-shutdown waits for {{minutes}} minutes without players.',
    autoShutdownEnabled: 'Auto-shutdown is enabled ({{minutes}} idle minutes).',
  },

  // Server statuses
  serverStatus: {
    running: 'running',
    stopped: 'stopped',
    creating: 'creating',
    starting: 'starting',
    stopping: 'stopping',
    restarting: 'restarting',
    deleting: 'deleting',
    error: 'error',
    suspended: 'suspended',
  },

  serverOperation: {
    phases: {
      preparing_server_data: 'Preparing server data',
      selecting_host: 'Selecting an available host',
      moving_server: 'Moving the server',
      starting: 'Starting the server',
    },
    errors: {
      no_start_placement_available: 'No eligible host is available right now. Try starting the server again later.',
      server_data_not_ready: 'Server data is not ready yet. Wait for preparation to finish, then try again.',
      generic: 'The server could not be started. Try again or contact support if the problem continues.',
    },
  },

  // Server Details Page
  serverDetails: {
    notFound: 'Server Not Found',
    notFoundDesc: 'Server does not exist.',
    backToDashboard: 'Back to Dashboard',
    onlinePlayers: 'Online Players',
    connection: 'Connection',
    serverAddress: 'Server Address',
    directIp: 'Direct IP',
    dnsPending: 'DNS pending',
    details: 'Details',
    package: 'Package',
    legacyPackage: 'Legacy package',
    runtime: 'Runtime',
    specHash: 'Applied spec hash',
    memoryLimit: 'Applied RAM',
    cpuLimit: 'Applied CPU',
    storageLimit: 'Applied storage',
    maxPlayersLimit: 'Applied max players',
    version: 'Version',
    serverType: 'Server type',
    difficulty: 'Difficulty',
    mode: 'Mode',
    motd: 'MOTD',
    created: 'Created',
    container: 'Container',
    actions: 'Actions',
    start: 'Start',
    stop: 'Stop',
    restart: 'Restart',
    files: 'Files',
    dockerLogs: 'Docker Logs',
    minecraftConsole: 'Minecraft Console',
    delete: 'Delete',
    host: 'Host',
    agent: 'Agent',
    region: 'Region',
    containers: 'Containers',
    updated: 'Updated',
    ramAllocated: 'RAM Allocated',
    game: 'Game',
    loadFailed: 'Failed to load the server.',
    retryLoad: 'Retry',
    refreshFailed: 'The latest server state could not be refreshed.',
    operationRejected: 'The command was not accepted',
    retryableError: 'This is a retryable failure. Refresh the state and try again when the operation is available.',
    serverError: 'The server needs attention',
    operationInProgress: '{{operation}} is in progress',
    waitForCompletion: 'The request was accepted. Waiting for the durable operation to complete.',
    retryScheduled: 'Automatic retry scheduled for {{time}}.',
    provisioning: 'Provisioning server...',
    starting: 'Starting server...',
    operationPhase: '{{operation}} · {{phase}}',
    deleteConfirm: 'Delete "{{name}}"? The server, world files and DNS will be removed after Agent confirmation.',
    actionFailed: 'Failed to {{action}} the server.',
    actionAccepted: '{{action}} request accepted.',
    autoShutdownTitle: 'Auto-shutdown enabled',
    autoShutdownScheduled: 'No players are online. The server will stop at {{time}} after {{minutes}} idle minutes.',
    autoShutdownWaiting: 'The server will be scheduled to stop after {{minutes}} minutes without players once fresh player data confirms it is idle.',
    autoShutdownEnabled: 'The policy will apply after the server starts: {{minutes}} minutes without players.',
  },

  dockerLogs: {
    title: 'Docker Logs — {{name}}',
    older: 'Older',
    clear: 'Clear',
    autoScroll: 'Auto-scroll',
    manualScroll: 'Manual scroll',
    retry: 'Retry',
    empty: 'No Docker logs available',
    lineCount: '{{count}} lines',
    live: 'Live',
    snapshotOnly: 'Snapshot only',
    loadFailed: 'Failed to load Docker logs',
    olderFailed: 'Failed to load older Docker logs',
    liveFailed: 'Live Docker log stream failed',
  },

  minecraftConsole: {
    title: 'Minecraft Console — {{name}}',
    clear: 'Clear local transcript',
    empty: 'No commands in this local session.',
    placeholder: 'Enter a Minecraft command…',
    commandLabel: 'Minecraft command',
    send: 'Send',
    sending: 'Sending once…',
    noOutput: '(No output)',
    duration: '{{duration}} ms',
    truncated: 'output truncated',
    historyHint: 'Enter sends once. Use ↑ and ↓ for local command history.',
    errors: {
      timeout: 'The Minecraft command timed out. It was not retried.',
      resultUnknown: 'The command may have run, but its result is unknown. It was not retried.',
      agentOffline: 'The Host-Agent is offline. Minecraft Console is unavailable.',
      serverStopped: 'Start the Minecraft server before sending a command.',
      serverBusy: 'Another server operation is in progress. Wait for it to finish.',
      unsupported: 'This pinned runtime does not support Minecraft Console.',
      rconUnavailable: 'Minecraft RCON is unavailable inside the running server.',
      unavailable: 'Minecraft Console is unavailable.',
    },
  },

  backups: {
    title: 'Backups',
    retention: 'The latest {{count}} completed backups are retained.',
    create: 'Create backup',
    operationActive: 'A backup or restore operation is in progress',
    empty: 'No backups yet.',
    restore: 'Restore over the current server',
    restoreConfirmTitle: 'Replace the current server data?',
    restoreConfirmWarning: 'The current data will be permanently replaced with this backup. The server will be stopped safely and restarted automatically if it was running.',
    restoreConfirm: 'Confirm restore',
    latestRestore: 'Latest restore',
    restorePending: 'Pending',
    restoreInProgress: 'In progress',
    restoreSucceeded: 'Completed',
    restoreFailedStatus: 'Failed',
    restorePhase: 'Phase: {{phase}}',
    restoreAttempts: 'Attempts: {{count}}',
    restoreRetryAt: 'Next attempt: {{time}}',
    download: 'Download',
    loadFailed: 'Backups could not be loaded.',
    createFailed: 'The backup request failed.',
    restoreFailed: 'The restore request failed.',
    downloadFailed: 'The backup could not be downloaded.',
  },

  // Create Server Modal
  createServer: {
    settingsLoading: 'Package settings are still loading.',
    settingsLoadError: 'Could not load the package settings.',
    noPackagesForGame: 'No active package is available for this game.',
    createFailed: 'Could not create the server.',
    noCpuCapacity: 'No eligible VPC currently has enough reserved CPU capacity for this package. Release capacity or try again later.',
    noMemoryCapacity: 'No eligible VPC currently has enough reserved RAM capacity for this package. Release capacity or try again later.',
    noStorageCapacity: 'No eligible VPC currently has enough reserved storage capacity for this package. Release capacity or try again later.',
    noWeightCapacity: 'The configured package weight capacity is full on every eligible VPC.',
    noPackageCapacity: 'The package instance limit is reached on every eligible VPC.',
    noPortCapacity: 'No eligible VPC currently has the required host ports available for this server.',
    noGenericCapacity: 'No eligible VPC currently has all required reserved resources and host ports for this package.',
    invalidCreateResponse: 'The server was accepted, but its identifier was missing from the response.',
    sensitiveDefaultPlaceholder: 'Leave blank to use the configured default',
    sensitiveDefaultHelp: 'A default is configured. Leave this blank to use it.',
    title: 'New Server',
    serverDetails: 'Server Details',
    subdomain: 'Subdomain',
    subdomainHelp: '{{name}}.hostinator.ro',
    displayName: 'Display Name',
    displayNamePlaceholder: 'My Awesome Server',
    selectPackage: 'Select Package',
    settings: 'Settings',
    subdomainError: 'Subdomain: lowercase letters, numbers, hyphens only',
    selectPackageError: 'Select a package',
    subdomainTaken: 'Subdomain already taken',
    invalidSubdomain: 'Invalid subdomain',
    creating: 'Creating...',
    createServer: 'Create Server',
  },

  // Admin Page
  admin: {
    title: 'Admin',
    subtitle: 'Manage platform',
    vpcs: 'VPCs',
    packages: 'Packages',
    commands: 'Commands',
    vpcManagement: 'VPC Management',
    addVpc: 'Add VPC',
    filterStatus: 'Status',
    filterName: 'Name',
    filterProvider: 'Provider',
    filterIp: 'IP',
    searchName: 'Search name...',
    searchProvider: 'Provider...',
    searchIp: 'IP address...',
    tableStatus: 'Status',
    tableName: 'Name',
    tableAddress: 'Address',
    tableSpecs: 'Specs',
    tableUsage: 'Usage',
    tableActions: 'Actions',
    noVpcs: 'No VPCs found',
    totalVpcs: '{{count}} total VPCs',
    cores: 'cores',
    storage: 'storage',
    containers: 'containers',
    unknown: 'Unknown',
  },

  // Maintenance page
  maintenance: {
    title: 'Under Construction',
    subtitle: "We're building something great-inator!",
    description: 'Hostinator is being prepared. Come back soon for the best hosting experience!',
    checkBack: 'Check back later',
  },

  // Games Page
  games: {
    badge: 'Supported Games',
    title: 'Available Games',
    subtitle: 'Hostinator supports multiple games, with more on the way. Vote for your favorite!',
    supportedTitle: 'Available Now',
    available: 'Available',
    upcomingTitle: 'Coming Soon',
    upcomingSubtitle: 'These games will be supported soon. Vote to speed things up!',
    comingSoon: 'Coming soon',
    votes: 'votes',
    vote: 'Vote',
    voted: 'Voted',
    voteInfo: 'You can vote once per day for each game. Log in to vote.',
  },

  // Home game selector
  homeGames: {
    selectGame: 'Select game',
    minecraft: 'Minecraft',
    valheim: 'Valheim',
  },

  // Create server game step
  createServerGame: {
    chooseGame: 'Choose your game',
    chooseGameSubtitle: 'Select the game you want to create a server for',
  },

  // Nav
  navGames: {
    games: 'Games',
  },
} as const;
